const API_BASE_URL = "https://rmpapi.iworkx.in"; // ✅ Base API URL

const api = {
  /* -------------------- Core Helpers -------------------- */
  get: async (endpoint, params = {}) => {
    const url = new URL(`${API_BASE_URL}/${endpoint}`);
    const dbKey = sessionStorage.getItem("databaseKey");
    if (dbKey && !params.databaseKey) {
      params.databaseKey = dbKey;
    }

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    const response = await fetch(url);
    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP GET error! status: ${response.status}, body: ${text}`);
    }
    return await response.json();
  },

  post: async (endpoint, body = {}) => {
    const dbKey = sessionStorage.getItem("databaseKey");
    const url = new URL(`${API_BASE_URL}/${endpoint}`);
    if (dbKey) {
      url.searchParams.append("databaseKey", dbKey);
    }

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP POST error! status: ${response.status}, body: ${text}`);
    }
    return await response.json();
  },

  /* -------------------- API Endpoints -------------------- */
  checkLoginInspection: (userName, userpwd) =>
    api.post("CheckLoginInspection", { UserName: userName, Userpwd: userpwd }),

  uploadInspectionReport: (data) =>
    api.post("InspectionReportUpload", data),

  getInspectionDatas: (User) =>
    api.get("GetInspectionDatas", { User }),

  getSupplierDatas: (User) =>
    api.get("GetSupplierDatas", { User }),

  getGipDatas: (Vid) =>
    api.get("GetGipDatas", { Vid }),

};

export default api;
